import { stepcountsConstants } from '../constants';
import defaultImage from "assets/img/image_placeholder.jpg";
import lodash from 'lodash';

var initialState = {
    formOpen: false,
    formMode: 'add',
    formInitialValue: {},
    tableKey: 0,
    tableData: {
        data: [],
        total: 0
    },
    tableReset: false,
    tableReload: false,
    allProductList: [],
    productList: [],
    selectedProductList: [],
    formProductListLoader: false,
    tableLoader: false,
    formMemberLevellist: [],
    singleProductList: [{_id: 0}],
    joinedProductList: [{_id: 0}],
    joinedProductRows : [
        {
            productWithQty: [{_id: 0, qty: 0}, {_id: 1, qty: 0}],
            point: 0
        },
    ],
    regionList:[],
    regionSelected:[],
    allShopList:[],
    shopList:[],
    allShopListSelected:[],
    shopListSelected:[],
    productListMaster:[],
    formImportOpen: false,
    formImportInitialValue: {},
    showImportResult: false,
    importResult: {},
    rewardImagePreview: defaultImage,
}

export function stepcounts(state = initialState, action) {
    switch (action.type) {
        case stepcountsConstants.CLEAR_PAGE_STATE:
            return initialState
        case stepcountsConstants.OPEN_ADD_NEW_STEP_COUNTS:
            return {
                ...state,
                formOpen: true,
                formMode: 'add',
                formInitialValue: action.data,
                rewardImagePreview: defaultImage,
            };
        case stepcountsConstants.OPEN_EDIT_STEP_COUNTS:
            return {
                ...state,
                formOpen: true,
                formMode: 'edit',
                formInitialValue: action.data,
                selectedProductList: action.selectedProductList,
                allShopListSelected:action.allShopListSelected,
                shopListSelected:action.allShopListSelected,
                regionSelected:action.regionSelected,
                productListMaster:action.productListMaster,
                rewardImagePreview: action.rewardImagePreview,
            };
        case stepcountsConstants.CLOSE_FORM_STEP_COUNTS:
            return {
                ...state,
                formOpen: false,
                formInitialValue: {
                    rewardImagePreview: ""
                },
                singleProductList: [{_id: 0}],
                joinedProductList: [{_id: 0}],
                joinedProductRows : [
                    {
                        productWithQty: [{_id: 0, qty: 0}, {_id: 1, qty: 0}],
                        point: 0
                    },
                ],
                rewardImagePreview: defaultImage
            }
        case stepcountsConstants.SET_FORM_PREVIEW_IMAGE_REWARD:
            return {
                ...state,
                rewardImagePreview: action.rewardImagePreview === "default" ? defaultImage : action.rewardImagePreview
            }
        case stepcountsConstants.GET_STEP_COUNTS_DATA_SUCCESS: {
            return {
                ...state,
                tableData: action.data,
                tableReload: false,
                tableReset: false
            }
        }
        case stepcountsConstants.GET_PRODUCT_LIST_SUCCESS: {
            let selectedProductList = state.selectedProductList;
            let productList = action.productList;

            lodash.each(selectedProductList, function (currentObject) {
                productList = productList.filter(function (obj) {
                    return obj._id !== currentObject._id;
                });
            })

            return {
                ...state,
                allProductList: action.productList,
                productList: productList
            }
        }
        case stepcountsConstants.STEP_COUNT_TYPECODE_SELECTED_PRODUCT_ITEM: {
            let productData = action.data;
            let newProductList = state.productList;
            let selectedProductList = state.selectedProductList;
            newProductList = newProductList.filter(function (obj) {
                return obj._id !== productData._id;
            });

            // console.log('newProductList :',newProductList);
            selectedProductList.push(productData)

            return {
                ...state,
                productList: newProductList,
                selectedProductList: selectedProductList
            }
        }
        case stepcountsConstants.STEP_COUNT_TYPECODE_SELECTED_MANY_PRODUCT_ITEM: {
            let productDataList = action.data;
            let selectedProductList = state.selectedProductList;

            return {
                ...state,
                productList: [],
                selectedProductList: lodash.unionBy(productDataList, selectedProductList, '_id')
            }
        }
        case stepcountsConstants.STEP_COUNT_TYPECODE_DESELECTED_PRODUCT_ITEM: {
            let productData = action.data;
            let productList = state.productList;
            let selectedProductList = state.selectedProductList;

            selectedProductList = selectedProductList.filter(function (obj) {
                return obj._id !== productData._id;
            });

            productList.push(productData)
            productList = lodash.orderBy(productList, ['updated_at'], ['desc']);

            return {
                ...state,
                productList: productList,
                selectedProductList: selectedProductList
            }
        }
        case stepcountsConstants.ON_STEPCOUNT_TYPE_CHANGE_TO_CODE: { 
            return {
                ...state,
                selectedProductList: []
            }
        }
        case stepcountsConstants.ON_STEPCOUNT_TYPE_CHANGE_TO_PRODUCT: {
            return {
                ...state,
                singleProductList: [{_id: 0}],
                joinedProductList: [{_id: 0}],
                joinedProductRows : [
                    {
                        productWithQty: [{_id: 0, qty: 0}, {_id: 1, qty: 0}],
                        point: 0
                    },
                ]
            }
        }
        case stepcountsConstants.STEPCOUNTS_FORM_PRODUCT_LIST_LOADER: {
            let showLoader = action.showLoader
            return {
                ...state,
                formProductListLoader: showLoader
            }
        }
        case stepcountsConstants.SHOW_TABLE_LOADER: {
            return {
                ...state,
                tableLoader: true
            }
        }
        case stepcountsConstants.HIDE_TABLE_LOADER: {
            return {
                ...state,
                tableLoader: false
            }
        }
        case stepcountsConstants.ADD_STEP_COUNTS_SUCCESS: {
            return {
                ...state,
                formOpen: false,
                formInitialValue: {},
                tableReload: false,
                tableReset: true,
                tableKey: new Date(),
                singleProductList: [{_id: 0}],
                joinedProductList: [{_id: 0}],
                joinedProductRows : [
                    {
                        productWithQty: [{_id: 0, qty: 0}, {_id: 1, qty: 0}],
                        point: 0
                    },
                ],
            }
        }
        case stepcountsConstants.EDIT_STEP_COUNTS_SUCCESS: {
            return {
                ...state,
                formOpen: false,
                formInitialValue: {},
                tableReload: true,
                tableReset: false,
                singleProductList: [{_id: 0}],
                joinedProductList: [{_id: 0}],
                joinedProductRows : [
                    {
                        productWithQty: [{_id: 0, qty: 0}, {_id: 1, qty: 0}],
                        point: 0
                    },
                ],
            }
        }
        case stepcountsConstants.TABLE_RELOAD_SUCCESS: {
            return {
                ...state,
                tableReload: false,
                tableReset: false
            }
        }
        case stepcountsConstants.DELETE_STEP_COUNTS_SUCCESS: {
            return {
                ...state,
                tableReload: true
            }
        }
        case stepcountsConstants.GET_MEMBER_LEVEL_LIST_SUCCESS: {
            return {
                ...state,
                formMemberLevellist: action.tmp
            }
        }
        case stepcountsConstants.STEP_COUNT_ADD_JOINED_PRODUCT_ROW: {
            let stateJoinedProductRow = state.joinedProductRows;
            stateJoinedProductRow.push(
                {
                    productWithQty: [{_id: 0, qty: 0}, {_id: 1, qty: 0}],
                    point: 0
                }
            )
            return {
                ...state,
                joinedProductRows: stateJoinedProductRow
            }
        } 
        case stepcountsConstants.STEP_COUNT_ADD_JOINED_PRODUCT: {
            let stateJoinedProductRow = state.joinedProductRows;
            stateJoinedProductRow[action.index].productWithQty.push(action.productWithQty)
            return {
                ...state,
                joinedProductRows: stateJoinedProductRow
            }
        } 
        case stepcountsConstants.STEP_COUNT_ADD_SINGLE_PRODUCT: {
            let stateSingleProductRow = state.singleProductList;
            stateSingleProductRow.push(action.objSingle)
            return {
                ...state,
                singleProductList: stateSingleProductRow
            }
        } 
        case stepcountsConstants.STEP_COUNT_DELETE_JOINED_PRODUCT: {
            let stateJoinedProductRow = state.joinedProductRows;
            stateJoinedProductRow[action.index].productWithQty.pop();
            return {
                ...state,
                joinedProductRows: stateJoinedProductRow
            }
        }
        case stepcountsConstants.STEP_COUNT_GET_REGION_LIST: {
            return {
                ...state,
                regionList: action.data 
            }
        } 
        case stepcountsConstants.STEP_COUNT_GET_SHOP_LIST: {
            return {
                ...state,
                allShopList: action.data.shopList ,
                shopList:action.data.shopList,
                allShopListSelected:action.data.shopListSelected,
                shopListSelected:action.data.shopListSelected,
            }
        } 
        case stepcountsConstants.STEP_COUNT_SELECT_SHOP: {
            return {
                ...state,
                shopList:action.data.shopList,
                allShopList:action.data.allShopList,
                shopListSelected:[...state.shopListSelected,...action.data.shopListSelected],
                allShopListSelected:[...state.allShopListSelected,...action.data.shopListSelected],
            }
        } 
        case stepcountsConstants.STEP_COUNT_UNSELECT_SHOP: {
            return {
                ...state,
                shopList:[...action.data.shopList,...state.shopList],
                allShopList:[...action.data.shopList,...state.allShopList],
                shopListSelected:action.data.shopListSelected,
                allShopListSelected:action.data.allShopListSelected,
            }
        } 
        case stepcountsConstants.STEP_COUNT_SELECTED_REGION: {
            return {
                ...state,
                regionSelected:action.data,
            }
        } 
        case stepcountsConstants.STEP_COUNT_SELECT_ALL_SHOP_LIST: {
            return {
                ...state,
                shopListSelected:[...action.data,...state.shopListSelected],
                shopList:[],
                allShopList:[],
                allShopListSelected:[...action.data,...state.shopListSelected],
            }
        } 
        case stepcountsConstants.STEP_COUNT_UNSELECT_ALL_SHOP_LIST: {
            return {
                ...state,
                shopList:[...action.data,...state.shopList],
                shopListSelected:[],
                allShopList:[...action.data,...state.shopList],
                allShopListSelected:[],
            }
        }
        case stepcountsConstants.STEP_COUNT_SEARCH_SHOP_LIST: {
            return {
                ...state,
                shopList:action.data,
            }
        }
        case stepcountsConstants.STEP_COUNT_SEARCH_SHOP_SELECTED: {
            return {
                ...state,
                shopListSelected:action.data,
            }
        }
        case stepcountsConstants.STEP_COUNT_CLEAR_SHOP_LIST: {
            return {
                ...state,
                allShopList:[],
                shopList:[],
                allShopListSelected:[],
                shopListSelected:[],
                regionSelected:[],
            }
        }
        case stepcountsConstants.GET_LUCKY_DRAW_REWARD_SET_SUCCESS: {
            return {
                ...state,
                luckyDrawRewardSet: action.data.rewards
            }
        }
        case stepcountsConstants.OPEN_STEP_COUNT_FORM_IMPORT: {
            return {
                ...state,
                formImportOpen: true,
                formImportInitialValue: (action.formImportInitialValue? action.formImportInitialValue:{})
            }
        }     
        case stepcountsConstants.CLOSE_STEP_COUNT_FORM_IMPORT: {
            return {
                ...state,
                formImportOpen: false,
                formImportInitialValue: {}
            }
        }   
        case stepcountsConstants.SHOW_STEP_COUNT_IMPORT_PRODUCT_RESULT: {
            return {
                ...state,
                formImportOpen: false,
                formImportInitialValue: {},
                showImportResult: true,
                importResult: action.data
            }
        }
        case stepcountsConstants.HIDE_STEP_COUNT_IMPORT_PRODUCT_RESULT:
            return {
                ...state,
                showImportResult: false,
                importResult: {}
            }
        default:
            return state;
    }
}